/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Ein Sammelversand an die markierten Datensaetze.
 * @export
 * @interface MailversandRequest
 */
export interface MailversandRequest {
    /**
     * Die MARKIERTEN Datensaetze. Eine leere Liste bewirkt nichts.
     * @type {Array<string>}
     * @memberof MailversandRequest
     */
    entryIds: Array<string>;
    /**
     * Das Feld, das die Empfaengeradresse traegt. Ausdruecklich uebergeben und nicht erraten: Eine Datenbank kann mehrere Adressfelder haben (Kunde, Vertretung, Rechnungsempfaenger), und welches gemeint ist, weiss nur der Absender. Ein geratenes Feld waere ein Versand an die Falschen -- und der laesst sich nicht zurueckholen.
     * @type {string}
     * @memberof MailversandRequest
     */
    emailFieldId: string;
    /**
     * Die eigene Mail-Vorlage der Datenbank (die `id` aus `emailTemplates`), mit der verschickt wird.
     * @type {string}
     * @memberof MailversandRequest
     */
    templateId: string;
    /**
     * Erstellt eine Protokolldatei ueber den Versand und schickt sie an den Eigentuemer der Datenbank. Darin steht je Datensatz die Adresse und ob die Mail rausging -- die einzige Spur, die ein Sammelversand sonst hinterlaesst, ist der Zaehler auf dem Bildschirm, und der ist beim naechsten Neuladen weg.
     * @type {boolean}
     * @memberof MailversandRequest
     */
    protokoll?: boolean;
}

/**
 * Check if a given object implements the MailversandRequest interface.
 */
export function instanceOfMailversandRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "entryIds" in value;
    isInstance = isInstance && "emailFieldId" in value;
    isInstance = isInstance && "templateId" in value;

    return isInstance;
}

export function MailversandRequestFromJSON(json: any): MailversandRequest {
    return MailversandRequestFromJSONTyped(json, false);
}

export function MailversandRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailversandRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entryIds': json['entryIds'],
        'emailFieldId': json['emailFieldId'],
        'templateId': json['templateId'],
        'protokoll': !exists(json, 'protokoll') ? undefined : json['protokoll'],
    };
}

export function MailversandRequestToJSON(value?: MailversandRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entryIds': value.entryIds,
        'emailFieldId': value.emailFieldId,
        'templateId': value.templateId,
        'protokoll': value.protokoll,
    };
}

